import React, { useState, useEffect } from 'react';
import LiveScoreDisplay from './LiveScoreDisplay';

function CourtZonesTest({ onBack, onOrientationChange, match, currentScore }) {
  // const [selectedZone, setSelectedZone] = useState(null); // non utilisé
  const [orientation] = useState('portrait');
  
  const [tapCount, setTapCount] = useState(0);
  const [currentSide, setCurrentSide] = useState('bottom');
  const [reboundZone, setReboundZone] = useState(null);
  const [shotZone, setShotZone] = useState(null);
  const [selectedShotType, setSelectedShotType] = useState(null);
  const [serverPosition, setServerPosition] = useState(50); // Position du serveur (0-100)
  const [isDragging, setIsDragging] = useState(false); // Pour le drag & drop
  const [isServerPositionLocked, setIsServerPositionLocked] = useState(false); // Position serveur validée

  // Fonction pour déterminer le côté de service (égalité = droite, avantage = gauche)
  const getServiceSide = () => {
    if (!currentScore?.jeuScore) return 'droite'; // Par défaut
    
    const [scoreJ1, scoreJ2] = currentScore.jeuScore.split('-');
    
    // Scores d'égalité (service à droite)
    const equalityScores = [
      ['0', '0'], ['15', '15'], ['30', '30'], ['40', '40'],
      ['30', '0'], ['40', '15'], ['0', '30'], ['15', '40']
    ];
    
    const isEquality = equalityScores.some(([s1, s2]) => s1 === scoreJ1 && s2 === scoreJ2);
    
    return isEquality ? 'droite' : 'gauche';
  };

  // Fonction pour calculer la position depuis un événement
  const updatePositionFromEvent = (e, rect) => {
    if (isServerPositionLocked) return; // Ne pas bouger si verrouillé
    
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const clickX = clientX - rect.left;
    const lineWidth = rect.width;
    
    const serviceSide = getServiceSide();
    
    if (serviceSide === 'droite') {
      // Service à droite : de 50% à 100% de la ligne
      const rightHalfStart = lineWidth * 0.5;
      const rightHalfWidth = lineWidth * 0.5;
      const relativeX = clickX - rightHalfStart;
      
      // Convertir en pourcentage de 0 à 100 dans la zone droite
      let position = (relativeX / rightHalfWidth) * 100;
      position = Math.max(0, Math.min(100, position));
      
      setServerPosition(position);
    } else {
      // Service à gauche : de 0% à 50% de la ligne
      const leftHalfWidth = lineWidth * 0.5;
      
      // Convertir en pourcentage de 0 à 100 dans la zone gauche
      let position = (clickX / leftHalfWidth) * 100;
      position = Math.max(0, Math.min(100, position));
      
      setServerPosition(position);
    }
  };

  // Fonction pour valider la position du serveur (clic sur le curseur)
  const handleServerPositionValidation = () => {
    if (!isServerPositionLocked && tapCount === 0) {
      setIsServerPositionLocked(true);
      // Rotation du terrain pour voir le côté adverse
      setTimeout(() => {
        setCurrentSide(currentSide === 'bottom' ? 'top' : 'bottom');
        setTapCount(1); // Prêt à cliquer sur zone de service
      }, 300);
    }
  };

  // Debug: vérifier si currentScore est bien passé
  useEffect(() => {
    console.log("CourtZonesTest - match:", match);
    console.log("CourtZonesTest - currentScore:", currentScore);
    console.log("CourtZonesTest - Service side:", getServiceSide());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [match, currentScore]);

  // Réinitialiser la position du serveur au début de chaque point
  useEffect(() => {
    if (tapCount === 0) {
      setServerPosition(50); // Centre par défaut
      setIsServerPositionLocked(false); // Déverrouiller
    }
  }, [tapCount]);

  // ========================================
  // SYSTÈME DE NUMÉROTATION DYNAMIQUE - OPTION 2
  // Principe: Depuis VOTRE point de vue, Gauche=IMPAIR, Droite=PAIR TOUJOURS
  // ========================================

  // Mapping des positions logiques vers les numéros
  // Principe: Gauche=IMPAIR, Droite=PAIR dans les DEUX vues
  // Format: 'LogicalID' : [numeroVueBottom, numeroVueTop]
  const zoneMapping = {
    // LIGNE 1 - Service haut (près du filet)
    'L1_CG': [7, 8],    'L1_G2': [3, 4],   'L1_G1': [1, 2],   
    'L1_D1': [2, 1],    'L1_D2': [4, 3],   'L1_CD': [8, 7],
    
    // LIGNE 2 - Service milieu  
    'L2_CG': [17, 18],   'L2_G1': [13, 14],  'L2_M': [11, 12],   
    'L2_D': [12, 11],    'L2_D1': [14, 13],  'L2_CD': [18, 17],
    
    // LIGNE 3 - Service bas (ligne du T) - SYMÉTRIQUE
    'L3_CG': [27, 28],   'L3_G3': [25, 26],  'L3_G2': [23, 24],  'L3_G1': [21, 22],  
    'L3_D1': [22, 21],   'L3_D2': [24, 23],  'L3_D3': [26, 25],  'L3_CD': [28, 27],
    
    // LIGNE 4 - Fond haut
    'L4_CG': [37, 38],   'L4_G2': [33, 34],  'L4_G1': [31, 32],  
    'L4_D1': [32, 31],   'L4_D2': [34, 33],  'L4_CD': [38, 37],
    
    // LIGNE 5 - Fond bas (près de la ligne de fond)
    'L5_CG': [47, 48],    'L5_G2': [43, 44],   'L5_G1': [41, 42],   
    'L5_D1': [42, 43],    'L5_D2': [44, 45],   'L5_CD': [48, 47],
    
    // HORS TERRAIN - Ligne 1 (juste derrière la ligne de fond)
    'H1_1': [57, 58],    'H1_2': [55, 56],   'H1_3': [53, 54],   'H1_4': [51, 52],   
    'H1_5': [52, 51],    'H1_6': [54, 53],   'H1_7': [56, 55],   'H1_8': [58, 57],
    
    // HORS TERRAIN - Ligne 2 (milieu) - SYMÉTRIQUE
    'H2_1': [67, 68],    'H2_2': [65, 66],   'H2_3': [63, 64],   'H2_4': [61, 62],   
    'H2_5': [62, 61],    'H2_6': [64, 63],   'H2_7': [66, 65],   'H2_8': [68, 67],
    
    // HORS TERRAIN - Ligne 3 (la plus loin)
    'H3_1': [77, 78],    'H3_2': [75, 76],   'H3_3': [73, 74],   'H3_4': [71, 72],   
    'H3_5': [72, 71],    'H3_6': [74, 73],   'H3_7': [76, 75],   'H3_8': [78, 77],
  };

  // Fonction pour obtenir le numéro de zone selon le côté actuel
  const getZoneNumber = (logicalId) => {
    const mapping = zoneMapping[logicalId];
    if (!mapping) return 0;
    return currentSide === 'bottom' ? mapping[0] : mapping[1];
  };

  // Fonction pour déterminer si une zone est impaire (pour la couleur)
  const isOddZone = (logicalId) => {
    const number = getZoneNumber(logicalId);
    return number % 2 !== 0;
  };

  // Fonction pour déterminer si une zone est dans les couloirs ou hors terrain
  const isOutsideOrCorridor = (logicalId) => {
    return logicalId.includes('_CG') || logicalId.includes('_CD') || logicalId.startsWith('H');
  };

  useEffect(() => {
    if (onOrientationChange) {
      onOrientationChange(orientation);
    }
  }, [orientation, onOrientationChange]);

  // Fonction pour générer les zones avec dimensions officielles tennis
  const generateZones = () => {
    const zones = [];
    
    // DIMENSIONS OFFICIELLES (en pourcentage du terrain)
    const COULOIR_WIDTH = 12.5;
    const TERRAIN_WIDTH = 75;
    const SERVICE_HEIGHT = 53.8;
    const FOND_HEIGHT = 46.2;
    const HALF_SERVICE_WIDTH = TERRAIN_WIDTH / 2;
    const X_CENTER_START = COULOIR_WIDTH;
    const X_CENTER_MID = COULOIR_WIDTH + HALF_SERVICE_WIDTH;
    
    // ========================================
    // CARRÉ DE SERVICE (0 à 53.8%)
    // ========================================
    const SERVICE_LINE_HEIGHT = SERVICE_HEIGHT / 3;
    
    // LIGNE 1 du service
    const y1 = 0;
    const h1 = SERVICE_LINE_HEIGHT;
    
    zones.push({ logicalId: 'L1_CG', x: -0.5, y: y1 + 4, width: COULOIR_WIDTH, height: h1 * 0.9 });
    zones.push({ logicalId: 'L1_G2', x: X_CENTER_START, y: y1 + 4, width: HALF_SERVICE_WIDTH / 2, height: h1 * 0.9 });
    zones.push({ logicalId: 'L1_G1', x: X_CENTER_START + HALF_SERVICE_WIDTH / 2.05, y: y1 + 4, width: HALF_SERVICE_WIDTH / 2, height: h1 * 0.9 });
    zones.push({ logicalId: 'L1_D1', x: X_CENTER_MID, y: y1 + 4, width: HALF_SERVICE_WIDTH / 2.02, height: h1 * 0.9 });
    zones.push({ logicalId: 'L1_D2', x: X_CENTER_MID + HALF_SERVICE_WIDTH / 2.1, y: y1 + 4, width: HALF_SERVICE_WIDTH / 2.02, height: h1 * 0.9 });
    zones.push({ logicalId: 'L1_CD', x: 99.5 - COULOIR_WIDTH, y: y1 + 4, width: COULOIR_WIDTH, height: h1 * 0.9 });
    
    // LIGNE 2 du service
    const y2 = y1 + h1;
    const h2 = SERVICE_LINE_HEIGHT;
    
    zones.push({ logicalId: 'L2_CG', x: -0.5, y: y2 + 1.6, width: COULOIR_WIDTH, height: h2 * 0.8});
    zones.push({ logicalId: 'L2_G1', x: X_CENTER_START , y: y2 + 1.6, width: HALF_SERVICE_WIDTH / 3, height: h2 * 0.8 });
    zones.push({ logicalId: 'L2_M', x: X_CENTER_START + HALF_SERVICE_WIDTH / 3.1, y: y2 + 1.6, width: HALF_SERVICE_WIDTH / 1.5, height: h2 * 0.8 });
    zones.push({ logicalId: 'L2_D', x: X_CENTER_MID, y: y2 + 1.6, width: HALF_SERVICE_WIDTH / 1.52, height: h2 * 0.8 });
    zones.push({ logicalId: 'L2_D1', x: X_CENTER_MID + HALF_SERVICE_WIDTH / 1.56, y: y2 + 1.6, width: HALF_SERVICE_WIDTH / 3, height: h2 * 0.8 });
    zones.push({ logicalId: 'L2_CD', x: 99.5 - COULOIR_WIDTH, y: y2 + 1.6, width: COULOIR_WIDTH, height: h2 * 0.8 });
    
    // LIGNE 3 du service
    const y3 = y2 + h2;
    const h3 = SERVICE_LINE_HEIGHT;
    
    zones.push({ logicalId: 'L3_CG', x: -0.5, y: y3 - 2.6, width: COULOIR_WIDTH, height: h3 * 0.48 });
    
    const zone_width_3 = HALF_SERVICE_WIDTH / 3;
    zones.push({ logicalId: 'L3_G3', x: X_CENTER_START, y: y3 - 2.6, width: zone_width_3, height: h3 * 0.48 });
    zones.push({ logicalId: 'L3_G2', x: X_CENTER_START + zone_width_3 * 0.98, y: y3 - 2.6, width: zone_width_3, height: h3 * 0.48 });
    zones.push({ logicalId: 'L3_G1', x: X_CENTER_START + zone_width_3 * 1.96, y: y3 - 2.6, width: zone_width_3, height: h3 * 0.48 });
    zones.push({ logicalId: 'L3_D1', x: X_CENTER_MID, y: y3 - 2.6, width: zone_width_3, height: h3 * 0.48 });
    zones.push({ logicalId: 'L3_D2', x: X_CENTER_MID + zone_width_3 * 0.95, y: y3 - 2.6, width: zone_width_3, height: h3 * 0.48 });
    zones.push({ logicalId: 'L3_D3', x: X_CENTER_MID + zone_width_3 * 1.90, y: y3 - 2.6, width: zone_width_3, height: h3 * 0.48 });
    zones.push({ logicalId: 'L3_CD', x: 99.5 - COULOIR_WIDTH, y: y3 - 2.6, width: COULOIR_WIDTH, height: h3 * 0.48 });
    
    // ========================================
    // FOND DE COURT (53.8% à 100%)
    // ========================================
    const FOND_START_Y = SERVICE_HEIGHT;
    const FOND_LINE_HEIGHT = FOND_HEIGHT / 2;
    
    // LIGNE 4 - Fond de court HAUT
    const y4 = FOND_START_Y;
    const h4 = FOND_LINE_HEIGHT;
    
    zones.push({ logicalId: 'L4_CG', x: -0.5, y: y4 - 11.5, width: COULOIR_WIDTH, height: h4 * 1.1});
    
    const fond_zone_width = TERRAIN_WIDTH / 4;
    zones.push({ logicalId: 'L4_G2', x: X_CENTER_START, y: y4 - 11.5, width: fond_zone_width, height: h4 * 1.1 });
    zones.push({ logicalId: 'L4_G1', x: X_CENTER_START + fond_zone_width - 0.5, y: y4 - 11.5, width: fond_zone_width, height: h4 * 1.1 });
    zones.push({ logicalId: 'L4_D1', x: X_CENTER_START + fond_zone_width * 1.97, y: y4 - 11.5, width: fond_zone_width, height: h4 * 1.1 });
    zones.push({ logicalId: 'L4_D2', x: X_CENTER_START + fond_zone_width * 2.95, y: y4 - 11.5, width: fond_zone_width, height: h4 * 1.1 });
    zones.push({ logicalId: 'L4_CD', x: 99.5 - COULOIR_WIDTH, y: y4 - 11.5, width: COULOIR_WIDTH, height: h4 * 1.1 });
    
    // LIGNE 5 - Fond de court BAS
    const y5 = y4 + h4;
    const h5 = FOND_LINE_HEIGHT;
    
    zones.push({ logicalId: 'L5_CG', x: -0.5, y: y5 -9.5, width: COULOIR_WIDTH, height: h5 * 0.45 });
    zones.push({ logicalId: 'L5_G2', x: X_CENTER_START, y: y5 -9.5, width: fond_zone_width, height: h5 * 0.45});
    zones.push({ logicalId: 'L5_G1', x: X_CENTER_START + fond_zone_width - 0.5, y: y5 -9.5, width: fond_zone_width, height: h5 * 0.45 });
    zones.push({ logicalId: 'L5_D1', x: X_CENTER_START + fond_zone_width * 1.97, y: y5 -9.5, width: fond_zone_width, height: h5 * 0.45 });
    zones.push({ logicalId: 'L5_D2', x: X_CENTER_START + fond_zone_width * 2.95, y: y5 -9.5, width: fond_zone_width, height: h5 * 0.45 });
    zones.push({ logicalId: 'L5_CD', x: 99.5 - COULOIR_WIDTH, y: y5 -9.5, width: COULOIR_WIDTH, height: h5 * 0.45 });
    
    // ========================================
    // HORS TERRAIN (3 lignes de 8 zones)
    // ========================================
    // const OUTSIDE_START_Y = 100;
    const OUTSIDE_HEIGHT = 15;
    const OUTSIDE_LINE_HEIGHT = OUTSIDE_HEIGHT / 3;
    const outside_zone_width = 100 / 8;
    const TERRAIN_SCALE = 85;
    
    // Rescaler toutes les zones terrain
    zones.forEach(zone => {
      zone.y = (zone.y * TERRAIN_SCALE) / 100;
      zone.height = (zone.height * TERRAIN_SCALE) / 100;
    });
    
    // Ligne 1 hors terrain
    const outside_y1 = TERRAIN_SCALE;
    const h1Numbers = ['H1_1', 'H1_2', 'H1_3', 'H1_4', 'H1_5', 'H1_6', 'H1_7', 'H1_8'];
    for (let i = 0; i < 8; i++) {
      zones.push({
        logicalId: h1Numbers[i],
        x: i * outside_zone_width,
        y: outside_y1 - 18,
        width: outside_zone_width,
        height: OUTSIDE_LINE_HEIGHT * 2
      });
    }
    
    // Ligne 2 hors terrain
    const outside_y2 = TERRAIN_SCALE + OUTSIDE_LINE_HEIGHT;
    const h2Numbers = ['H2_1', 'H2_2', 'H2_3', 'H2_4', 'H2_5', 'H2_6', 'H2_7', 'H2_8'];
    for (let i = 0; i < 8; i++) {
      zones.push({
        logicalId: h2Numbers[i],
        x: i * outside_zone_width,
        y: outside_y2 - 13,
        width: outside_zone_width,
        height: OUTSIDE_LINE_HEIGHT * 2
      });
    }
    
    // Ligne 3 hors terrain
    const outside_y3 = TERRAIN_SCALE + OUTSIDE_LINE_HEIGHT * 2;
    const h3Numbers = ['H3_1', 'H3_2', 'H3_3', 'H3_4', 'H3_5', 'H3_6', 'H3_7', 'H3_8'];
    for (let i = 0; i < 8; i++) {
      zones.push({
        logicalId: h3Numbers[i],
        x: i * outside_zone_width,
        y: outside_y3 - 8,
        width: outside_zone_width,
        height: OUTSIDE_LINE_HEIGHT * 2
      });
    }
    
    return zones;
  };

  const zones = generateZones();

  // Fonction pour obtenir les zones visibles selon le côté actuel
  const getVisibleZones = () => {
    // Avec la rotation CSS de 180°, les zones gardent leurs coordonnées d'origine
    return zones;
  };

  // Gestion des clics sur les zones
  const handleZoneClick = (logicalId) => {
    const zoneNumber = getZoneNumber(logicalId);
    
    if (tapCount === 1) {
      // Premier clic après validation position serveur : zone de service
      setReboundZone(zoneNumber);
      setTapCount(2);
    } else if (tapCount === 2) {
      // Deuxième tap : zone de frappe retour (premier coup après service)
      setShotZone(zoneNumber);
      setTapCount(3);
      
      // Changer de côté après un court délai
      setTimeout(() => {
        setCurrentSide(currentSide === 'bottom' ? 'top' : 'bottom');
        setReboundZone(null);
        setShotZone(null);
        setTapCount(4); // Continue le point (pas retour à 0)
      }, 100);
    } else if (tapCount >= 4) {
      // Suite de l'échange : alternance rebond/frappe
      if (!reboundZone) {
        setReboundZone(zoneNumber);
      } else {
        setShotZone(zoneNumber);
        
        // Changer de côté
        setTimeout(() => {
          setCurrentSide(currentSide === 'bottom' ? 'top' : 'bottom');
          setReboundZone(null);
          setShotZone(null);
        }, 100);
      }
    }
  };

  // Gestion des boutons de point
  const handlePointJ1 = () => {
    console.log('Point pour J1');
    // Réinitialiser l'état
    resetState();
  };

  const handlePointJ2 = () => {
    console.log('Point pour J2');
    // Réinitialiser l'état
    resetState();
  };

  // Gestion du 2ème service (retour à la position initiale)
  const handleSecondService = () => {
    // Rotation inverse pour revenir à la vue serveur
    setCurrentSide(currentSide === 'bottom' ? 'top' : 'bottom');
    setTapCount(0); // Retour au début
    setReboundZone(null);
    setShotZone(null);
    setIsServerPositionLocked(false); // Déverrouiller pour repositionner
  };

  const handleCancel = () => {
    resetState();
  };

  const resetState = () => {
    setTapCount(0);
    setCurrentSide('bottom');
    setReboundZone(null);
    setShotZone(null);
    setSelectedShotType(null);
  };

  const shotTypes = ['CD', 'RV', 'VOL', 'SMH', 'LOB', 'AUT'];

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f5f5f5',
      padding: '20px',
      fontFamily: 'system-ui, -apple-system, sans-serif'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        padding: '24px'
      }}>
        {/* SCORE LIVE */}
        <LiveScoreDisplay match={match} currentScore={currentScore} />

        <div style={{
          display: 'flex',
          gap: '8px',
          justifyContent: 'center',
          marginBottom: '20px',
          flexWrap: 'wrap'
        }}>
          {shotTypes.map(type => (
            <button
              key={type}
              onClick={() => setSelectedShotType(type)}
              style={{
                padding: '10px 16px',
                backgroundColor: selectedShotType === type ? '#4caf50' : '#e0e0e0',
                color: selectedShotType === type ? 'white' : '#333',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                boxShadow: selectedShotType === type ? '0 4px 8px rgba(76,175,80,0.4)' : '0 2px 4px rgba(0,0,0,0.1)',
                transition: 'all 0.2s'
              }}
            >
              {type}
            </button>
          ))}
        </div>

        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
        }}>
          <div style={{
            transform: orientation === 'landscape' ? 'rotate(-90deg)' : 'none',
            transformOrigin: 'center center',
            transition: 'transform 0.3s ease',
          }}>
            <div style={{
              position: 'relative',
              width: orientation === 'portrait' ? '400px' : '600px',
              height: orientation === 'portrait' ? '652px' : '245px',
              backgroundColor: '#FF6B35',
              border: '6px solid #333',
              borderRadius: '8px',
              boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
              overflow: 'hidden',
              transform: currentSide === 'top' ? 'rotate(180deg)' : 'none',
              transition: 'transform 0.5s ease'
            }}>
              
              {/* Zone hors terrain */}
              <div style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                right: 0,
                height: '33.5%',
                backgroundColor: '#4a5568',
                zIndex: 0
              }} />

              {/* LIGNES BLANCHES DU TERRAIN */}
              
              {/* Ligne de fond (haut du terrain) */}
              <div style={{
                position: 'absolute',
                top: '0%',
                left: '12.5%',
                right: '12.5%',
                height: '3px',
                backgroundColor: 'white',
                zIndex: 1
              }} />
              
              {/* Ligne de service (séparation service/fond) */}
              <div style={{
                position: 'absolute',
                top: '35.8%',
                left: '12.5%',
                right: '12.5%',
                height: '3px',
                backgroundColor: 'white',
                zIndex: 1
              }} />
              
              {/* Ligne de filet (bas du terrain / ligne de fond du demi-terrain) - INTERACTIVE pour position serveur */}
              <div 
                onMouseDown={(e) => {
                  if (tapCount === 0) {
                    setIsDragging(true);
                    const rect = e.currentTarget.getBoundingClientRect();
                    updatePositionFromEvent(e, rect);
                  }
                }}
                onMouseMove={(e) => {
                  if (isDragging && tapCount === 0) {
                    const rect = e.currentTarget.getBoundingClientRect();
                    updatePositionFromEvent(e, rect);
                  }
                }}
                onMouseUp={() => setIsDragging(false)}
                onMouseLeave={() => setIsDragging(false)}
                onTouchStart={(e) => {
                  if (tapCount === 0) {
                    setIsDragging(true);
                    const rect = e.currentTarget.getBoundingClientRect();
                    updatePositionFromEvent(e, rect);
                  }
                }}
                onTouchMove={(e) => {
                  if (isDragging && tapCount === 0) {
                    e.preventDefault(); // Empêcher le scroll
                    const rect = e.currentTarget.getBoundingClientRect();
                    updatePositionFromEvent(e, rect);
                  }
                }}
                onTouchEnd={() => setIsDragging(false)}
                style={{
                  position: 'absolute',
                  top: 'calc(66.5% - 10px)', // Zone cliquable élargie
                  left: '0%',
                  right: '0%',
                  height: '24px', // Zone cliquable élargie
                  cursor: tapCount === 0 ? (isDragging ? 'grabbing' : 'grab') : 'default',
                  zIndex: 10,
                  touchAction: 'none' // Améliore la gestion du touch
                }}
              >
                {/* Ligne blanche visible */}
                <div style={{
                  position: 'absolute',
                  top: '10px',
                  left: 0,
                  right: 0,
                  height: '4px',
                  backgroundColor: 'white',
                  zIndex: 1
                }} />
                
                {/* Curseur de position du serveur - Visible uniquement au tout début du point */}
                {tapCount === 0 && !isServerPositionLocked && (
                  <div 
                    onClick={handleServerPositionValidation}
                    style={{
                      position: 'absolute',
                      top: '2px',
                      left: (() => {
                        const serviceSide = getServiceSide();
                        if (serviceSide === 'droite') {
                          return `${50 + (serverPosition * 0.5)}%`;
                        } else {
                          return `${0 + (serverPosition * 0.5)}%`;
                        }
                      })(),
                      width: '24px',
                      height: '24px',
                      backgroundColor: isServerPositionLocked ? '#333' : (isDragging ? '#45a049' : '#4caf50'),
                      border: '4px solid white',
                      borderRadius: '50%',
                      transform: `translateX(-50%) scale(${isDragging ? 1.2 : 1})`,
                      zIndex: 2,
                      boxShadow: isServerPositionLocked
                        ? '0 4px 12px rgba(51,51,51,0.8)'
                        : (isDragging 
                          ? '0 6px 16px rgba(76,175,80,1)' 
                          : '0 4px 12px rgba(76,175,80,0.8)'),
                      transition: isDragging ? 'none' : 'all 0.3s',
                      pointerEvents: 'auto', // Rendre cliquable
                      cursor: isServerPositionLocked ? 'default' : 'pointer'
                    }} 
                  />
                )}
              </div>
              
              {/* Couloir gauche (ligne verticale) */}
              <div style={{
                position: 'absolute',
                top: '0%',
                bottom: '33.5%',
                left: '12.5%',
                width: '3px',
                backgroundColor: 'white',
                zIndex: 1
              }} />
              
              {/* Couloir droit (ligne verticale) */}
              <div style={{
                position: 'absolute',
                top: '0%',
                bottom: '33.5%',
                right: '12.5%',
                width: '3px',
                backgroundColor: 'white',
                zIndex: 1
              }} />
              
              {/* Ligne centrale (T du service) */}
              <div style={{
                position: 'absolute',
                top: '0%',
                bottom: '63.8%',
                left: '50%',
                width: '3px',
                backgroundColor: 'white',
                zIndex: 1
              }} />

              {/* BOUTON FILET - Entre le filet et la première ligne */}
              <div
                onClick={() => {
                  if (tapCount > 0) {
                    console.log('FAUTE DE FILET');
                    // Logique à implémenter : enregistrer faute filet
                  }
                }}
                style={{
                  position: 'absolute',
                  left: '12.5%',
                  right: '12.5%',
                  top: '-8%',
                  height: '11%',
                  backgroundColor: tapCount > 0 ? '#78909c' : '#5a6c7d',
                  border: '3px solid #000',
                  borderRadius: '8px',
                  display: 'flex',
                  alignItems: currentSide === 'top' ? 'flex-start' : 'flex-end',
                  justifyContent: 'center',
                  cursor: tapCount > 0 ? 'pointer' : 'default',
                  opacity: tapCount > 0 ? 1 : 0.6,
                  zIndex: 3,
                  transition: 'all 0.2s',
                  transform: currentSide === 'top' ? 'rotate(180deg)' : 'none'
                }}
              >
                <span style={{
                  color: 'white',
                  fontSize: '14px',
                  fontWeight: '700',
                  textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                  transform: currentSide === 'top' ? 'rotate(0deg)' : 'none',
                  display: 'block',
                  padding: '2px'
                }}>
                  FILET
                </span>
              </div>

              {/* Zones */}
              {getVisibleZones().map((zone) => {
                const zoneNumber = getZoneNumber(zone.logicalId);
                const isOdd = isOddZone(zone.logicalId);
                const isOutOrCorridor = isOutsideOrCorridor(zone.logicalId);
                
                // Couleur selon le type de zone
                let backgroundColor;
                if (zoneNumber === reboundZone) {
                  backgroundColor = '#4caf50'; // Vert pour zone de service sélectionnée
                } else if (zoneNumber === shotZone) {
                  backgroundColor = '#2196f3'; // Bleu pour zone de frappe sélectionnée
                } else if (isOutOrCorridor) {
                  backgroundColor = '#5a6c7d'; // Gris pour hors terrain et couloirs
                } else if (isOdd) {
                  backgroundColor = '#e74c3c'; // Rouge pour impairs (zones valides)
                } else {
                  backgroundColor = '#3498db'; // Bleu pour pairs (zones valides)
                }
                
                return (
                  <div
                    key={zone.logicalId}
                    onClick={() => handleZoneClick(zone.logicalId)}
                    style={{
                      position: 'absolute',
                      left: `${zone.x}%`,
                      top: `${zone.y}%`,
                      width: `${zone.width}%`,
                      height: `${zone.height}%`,
                      padding: '3px',
                      boxSizing: 'border-box',
                      zIndex: 2
                    }}
                  >
                    <div style={{
                      width: '100%',
                      height: '100%',
                      backgroundColor,
                      border: '2px solid #000',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '13px',
                      fontWeight: '700',
                      cursor: 'pointer',
                      userSelect: 'none',
                      textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                      transition: 'all 0.2s ease',
                      transform: (() => {
                        // Rotation pour orientation landscape
                        const landscapeRotation = orientation === 'landscape' ? 'rotate(90deg)' : '';
                        // Contre-rotation pour garder les numéros lisibles quand le terrain pivote
                        const sideRotation = currentSide === 'top' ? 'rotate(180deg)' : '';
                        
                        // Combiner les rotations
                        if (landscapeRotation && sideRotation) {
                          return `${landscapeRotation} ${sideRotation}`;
                        }
                        return landscapeRotation || sideRotation || 'none';
                      })(),
                    }}>
                      {zoneNumber}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        <div style={{
          marginTop: '24px',
          padding: '16px',
          backgroundColor: '#fff'
        }}>
          <div style={{ 
            display: 'flex', 
            gap: '12px', 
            justifyContent: 'center', 
            marginBottom: '16px',
            flexWrap: 'wrap'
          }}>
            {tapCount >= 1 && (
              <button 
                onClick={handleSecondService} 
                style={{ 
                  padding: '12px 24px', 
                  backgroundColor: '#ff9800', 
                  color: 'white', 
                  border: 'none', 
                  borderRadius: '8px', 
                  fontSize: '14px', 
                  fontWeight: '600', 
                  cursor: 'pointer', 
                  boxShadow: '0 4px 8px rgba(255,152,0,0.4)' 
                }}
              >
                2ème SERVICE
              </button>
            )}
            <button 
              onClick={handlePointJ1} 
              style={{ 
                padding: '12px 24px', 
                backgroundColor: '#1976d2', 
                color: 'white', 
                border: 'none', 
                borderRadius: '8px', 
                fontSize: '14px', 
                fontWeight: '600', 
                cursor: 'pointer', 
                boxShadow: '0 4px 8px rgba(25,118,210,0.4)' 
              }}
            >
              POINT J1
            </button>
            <button 
              onClick={handlePointJ2} 
              style={{ 
                padding: '12px 24px', 
                backgroundColor: '#1976d2', 
                color: 'white', 
                border: 'none', 
                borderRadius: '8px', 
                fontSize: '14px', 
                fontWeight: '600', 
                cursor: 'pointer', 
                boxShadow: '0 4px 8px rgba(25,118,210,0.4)' 
              }}
            >
              POINT J2
            </button>
            <button 
              onClick={handleCancel} 
              style={{ 
                padding: '12px 24px', 
                backgroundColor: '#d32f2f', 
                color: 'white', 
                border: 'none', 
                borderRadius: '8px', 
                fontSize: '14px', 
                fontWeight: '600', 
                cursor: 'pointer', 
                boxShadow: '0 4px 8px rgba(211,47,47,0.4)' 
              }}
            >
              ANNULER
            </button>
          </div>

          <div style={{ 
            padding: '12px', 
            backgroundColor: '#fff', 
            borderRadius: '8px', 
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)', 
            fontSize: '12px', 
            color: '#666', 
            textAlign: 'center', 
            marginBottom: '16px' 
          }}>
            {tapCount === 0 && !isServerPositionLocked && (
              <>
                🎾 Glissez le curseur 🟢 pour positionner le serveur
                <div style={{ marginTop: '4px', fontSize: '11px', color: '#4caf50', fontWeight: '600' }}>
                  Côté {getServiceSide() === 'droite' ? 'ÉGALITÉ (Droite)' : 'AVANTAGE (Gauche)'} - Position: {Math.round(serverPosition)}%
                </div>
                <div style={{ marginTop: '6px', fontSize: '11px', color: '#ff9800', fontWeight: '600' }}>
                  Puis cliquez sur le curseur pour valider ⬇️
                </div>
              </>
            )}
            {tapCount === 0 && isServerPositionLocked && <>⏳ Rotation du terrain vers le côté adverse...</>}
            {tapCount === 1 && <>🎯 Cliquez sur la zone de SERVICE (terrain adverse)</>}
            {tapCount === 2 && <>✅ Service zone {reboundZone} • Cliquez sur zone de FRAPPE (retour)</>}
            {tapCount === 3 && <>✅ Changement de côté...</>}
            {tapCount >= 4 && !reboundZone && <>🎾 Cliquez sur zone de REBOND</>}
            {tapCount >= 4 && reboundZone && <>✅ Rebond zone {reboundZone} • Cliquez sur zone de FRAPPE</>}
          </div> 
        </div> 
        
        <button 
          onClick={onBack} 
          style={{ 
            width: '100%', 
            padding: '12px 24px', 
            backgroundColor: '#1976d2', 
            color: 'white', 
            border: 'none', 
            borderRadius: '8px', 
            fontSize: '14px', 
            fontWeight: '600', 
            cursor: 'pointer', 
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)' 
          }}
        >
          ← Retour
        </button>
      </div>
    </div>
  );
}

export default CourtZonesTest;